import qs from "qs";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import SearchBox from "../../common/searchBox";
import Table from "../../common/table";
import { useGetAllGifts } from "../../../queryHooks";
import { getCurrentTimezoneDate } from "../../../util/columnsOrdering";
import CS from "../../../services/commonService";
import Icon from "../../icons/index";
import ReactTooltip from "react-tooltip";
import { URL } from "../../../constants/URL";
import { useStore } from "../../../zustand/store";
import { modules } from "../../../constants/Modules";
import RenderUser from "../../common/User";
//	Pre-defined values
const columnKey = "restaurantGiftOrders";
//	Component starts
const GiftsTable = ({ restaurantId, tabChangeCounter, tabKey }) => {
	const navigate = useNavigate();
	const lastPageData = useStore((state) => state.lastPageData);
	const setLastPageData = useStore((state) => state.setLastPageData);
	//	State values
	const [tableData, setTableData] = useState();
	const [pageNow, setPageNow] = useState(
		lastPageData?.[`${modules.CLAIM_GIFTS}${restaurantId}`]?.page || 1
	);
	const [itemsPerPage, setItemsPerPage] = useState(
		lastPageData?.[`${modules.CLAIM_GIFTS}${restaurantId}`]?.items_per_page ||
			10
	);
	const [giftsPayload, setGiftsPayload] = useState(
		lastPageData?.[`${modules.CLAIM_GIFTS}${restaurantId}`] || {
			pagination: true,
			items_per_page: itemsPerPage,
			page: pageNow,
			sort: { created_at: "DESC" },
			filter: { ["restaurant_id"]: restaurantId, ["status"]: 5 }, //5 is for status completed
		}
	);

	const { data: dataGetAllGifts, isLoading } = useGetAllGifts(
		qs.stringify(giftsPayload)
	);

	useEffect(() => {
		if (dataGetAllGifts && dataGetAllGifts.status === "success") {
			let respData = dataGetAllGifts.data;
			respData.page = pageNow;
			respData.items_per_page = itemsPerPage;
			setTableData(respData);
		}
	}, [dataGetAllGifts]);

	useEffect(() => {
		setGiftsPayload({
			...giftsPayload,
			filter: { ["restaurant_id"]: restaurantId, ["status"]: 5 },
			sort: { created_at: "DESC" },
		});
	}, [tabChangeCounter]);

	useEffect(() => {
		setPageNow(1);
		setItemsPerPage(10);
		setGiftsPayload({
			pagination: true,
			items_per_page: 10,
			page: 1,
			filter: { ["restaurant_id"]: restaurantId, ["status"]: 5 },
		});
	}, [restaurantId]);

	const setFilters = () => {
		setLastPageData({
			[`tabKey${restaurantId}`]: tabKey,
			[`${modules.CLAIM_GIFTS}${restaurantId}`]: giftsPayload,
		});
	};

	const columns = [
		{
			label: "Gift Id",
			type: "string",
			//sort: true,
			path: "gift_id",
		},
		{
			label: "Date",
			type: "date",
			sort: true,
			path: "created_at",
			alias: "created_at",
			filterDate: true,
			content: (item) => getCurrentTimezoneDate(item.created_at),
		},
		{
			label: "Gifted By",
			type: "string",
			sort: true,
			path: "giftedByName",
			aliasFilter: "gifter_id",
			filterUsers: true,
			content: (item) => (
				<Link
					to={{
						pathname: `${URL.onboarderedUsers}/${item.gifter?.id}`,
						state: { key: "giftOrders" },
					}}
					onClick={setFilters}
				>
					<RenderUser
						profileImageUrl={item?.gifter?.profile_image_url}
						firstName={item?.gifter?.first_name}
						lastName={item?.gifter?.last_name}
					/>
				</Link>
			),
		},
		{
			label: "Gifted To",
			type: "string",
			sort: true,
			path: "giftedToName",
			aliasFilter: "recipient_id",
			filterUsers: true,
			content: (item) => (
				<Link
					to={{
						pathname: `${URL.onboarderedUsers}/${item.recipient?.id}`,
						state: { key: "giftOrders" },
					}}
					onClick={setFilters}
				>
					<RenderUser
						profileImageUrl={item?.recipient?.profile_image_url}
						firstName={item?.recipient?.first_name}
						lastName={item?.recipient?.last_name}
					/>
				</Link>
			),
		},
		// {
		// 	label: "Total Amount",
		// 	type: "number",
		// 	sort: true,
		// 	path: "subTotal",
		// 	content: (item) => `$ ${item.subTotal || ""}`,
		// },
		{
			label: "Action",
			type: "boolean",
			content: (item) => (
				<>
					<Icon
						type="show"
						data-tip
						data-for="show"
						onClick={() => {
							setFilters();
							navigate(`${URL.giftOrders}/${item.id}`);
						}}
					/>
					<ReactTooltip id="show" place="top" effect="solid">
						Show
					</ReactTooltip>
				</>
			),
		},
	];

	return (
		<>
			<div className="dataTables_wrapper">
				<div className="content-area position-relative">
					<div className="grid">
						<div className="grid-content">
							<div className="user-listing-filterOptions mb-2 mt-3 d-block">
								<div className="row mb-2">
									<div className="col-sm-8 mb-2 position-static">
										<div className="left-buttons d-flex">
											<SearchBox
												columnKey={columnKey}
												searchValue={
													lastPageData?.[
														`${modules.CLAIM_GIFTS}${restaurantId}`
													]?.search?.first_name
												}
												search={(value) => {
													setPageNow(1);
													setGiftsPayload({
														...giftsPayload,
														search: {
															"data_restaurants.name":
																!value && value === "" ? undefined : value,
															"data_gifts.gift_id":
																!value && value === "" ? undefined : value,
															first_name:
																!value && value === "" ? undefined : value,
															last_name:
																!value && value === "" ? undefined : value,
														},
														page: 1,
													});
												}}
											/>
										</div>
									</div>
								</div>
							</div>
							<Table
								columnKey={columnKey}
								columns={columns}
								tableData={tableData}
								sortCol={(obj) => {
									setPageNow(1);
									setGiftsPayload({
										...giftsPayload,
										sort: {
											[obj.alias]:
												!obj.sort && obj.sort === "" ? undefined : obj.sort,
										},
										page: 1,
									});
								}}
								setCurrentPage={(page) => {
									setPageNow(page);
									setGiftsPayload({ ...giftsPayload, page });
								}}
								setCurrentLimit={(items_per_page) => {
									setPageNow(1);
									setItemsPerPage(items_per_page);
									setGiftsPayload({
										...giftsPayload,
										items_per_page,
										page: 1,
									});
								}}
								loading={isLoading}
								filterValue={async (obj) => {
									if (obj.filter === null) {
										const resp = await CS.filterData(giftsPayload.filter, obj);
										setPageNow(1);
										setGiftsPayload({
											...giftsPayload,
											filter: resp,
											page: 1,
										});
									} else {
										setPageNow(1);
										setGiftsPayload({
											...giftsPayload,
											filter: {
												...giftsPayload.filter,
												[obj.alias]: obj.filter,
											},
											page: 1,
										});
									}
								}}
								filterDate={(dates) => {
									setPageNow(1);
									setGiftsPayload({
										...giftsPayload,
										filter_date: dates && {
											...giftsPayload?.filter_date,
											[dates.alias]: String(dates.filter),
										},
										page: 1,
									});
								}}
								tabChangeCounter={tabChangeCounter}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default GiftsTable;
